export function getChangedFlightName(
	draft: string,
	currentFlightName: string | undefined,
): string | undefined {
	const flightName = draft.trim()
	return flightName && flightName !== currentFlightName
		? flightName
		: undefined
}
